export default {
  state: {
    am4core: {},
    am4Charts: {},
    loadedCharts: false,
  },
  getters: {
    am4core(state) {
      return state.am4core;
    },
    am4Charts(state) {
      return state.am4Charts;
    },
    loadedCharts(state) {
      return state.loadedCharts;
    },
  },
  actions: {
    INITIALIZE_CHART({ state }) {
      Promise.all([
        import('@amcharts/amcharts4/core'),
        import('@amcharts/amcharts4/lang/es_ES'),
        import('@amcharts/amcharts4/themes/animated'),
        import('@amcharts/amcharts4/charts'),
      ]).then((modules) => {
        state.am4core = modules[0];
        state.am4core.options.defaultLocale = modules[1];
        state.am4core.useTheme(modules[2].default);
        state.am4Charts = modules[3];
        return new Promise((resolve) => {
          state.am4core.options.queue = true;
          state.am4core.options.minPolylineStep = 5;
          state.am4core.options.onlyShowOnViewport = true;
          state.loadedCharts = true;
          resolve('ready');
        });
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/charts.js